import * as React from "react";

const SvgRewind = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M8.4 11.202a1 1 0 0 0 0 1.6l5.333 4a1 1 0 0 0 1.6-.8v-8a1 1 0 0 0-1.6-.8l-5.333 4Z" />
      <path d="M8.4 11.202a1 1 0 0 0 0 1.6l5.333 4a1 1 0 0 0 1.6-.8v-8a1 1 0 0 0-1.6-.8l-5.333 4Z" />
    </g>
  </svg>
);

export default SvgRewind;
